import client from './index'
import * as Predicates from './utils/predicates'
import * as Types from '@avcan/prismic/types'

export function get(locale) {
    const predicates = Predicates.rangeForType(Types.SPAW)

    return client.queryFirst(predicates, { locale })
}
